export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      genese: "D'où vient FACOW 360 ?",
      geobiologie: "Géobiologie",
      cuisine: "Cuisine Vivante",
      magnetisme: "Magnétisme",
      sentinelles: "Sentinelles Vertes",
      therapeutes: "Thérapeutes",
      boutique: "Boutique",
      bilan: "Bilan Vitalité",
      tarifs: "Tarifs",
      frequences: "Fréquences",
      devis: "Devis",
      contact: "Contact",
      legal: "Mentions Légales et CGV",
    },
    home: {
      tagline: "Plateforme d'Alchimie",
      hero_left_title: "L'IA au service du Vivant",
      hero_left_text: "La méthode FACOW 360 repose sur des services professionnels strictement dissociés : l'analyse de l'habitat (Géobiologie), le rééquilibrage énergétique (Magnétisme) et la Cuisine Vivante. L'approche nutritionnelle s'articule rigoureusement autour de 5 piliers : le système des groupes sanguins, l'Ayurvéda, la naturopathie, la chronobiologie et le jeûne.",
      hero_right_title: "Le respect de la Tradition",
      hero_right_text: "La sagesse des Runes, la Géobiologie et la Cuisine Vivante guident notre approche depuis des millénaires. Nous l'honorons, sans la trahir.",
      pillars_title: "3 Piliers de la Méthode FACOW 360",
      pillars_sub: "Chaque pilier est strictement dissocié pour préserver la lisibilité et la profondeur du conseil.",
      cta_chat: "Consulter l'IA experte",
      bottom_phrase: "Si vous en ressentez le besoin, une analyse serait idéale pour retrouver un équilibre correct.",
    },
    pillars: {
      geobiologie: {
        title: "Géobiologie",
        short: "Analyse de l'habitat (détection des perturbations et harmonisation des lieux de vie).",
      },
      cuisine: {
        title: "Cuisine Vivante",
        short: "Conseil et accompagnement nutritionnel personnalisé.",
      },
      magnetisme: {
        title: "Magnétisme",
        short: "Rééquilibrage énergétique (libération des tensions et harmonisation des flux).",
      },
      therapeutes: {
        title: "Thérapeutes recommandés",
        short: "Un réseau de praticiens vérifiés pour prolonger l'accompagnement avec rigueur.",
      },
      boutique: {
        title: "Boutique d'affiliation",
        short: "Une sélection d'objets et d'ouvrages alignés sur les sept livres de référence — aucune gestion de stock, transparence totale.",
      },
    },
    chatbot: {
      title: "FACOW360 — IA Experte",
      placeholder: "Posez votre question...",
      free_left: "{n} messages gratuits restants",
      paid_left: "{n} messages restants",
      locked: "Crédits épuisés. Rechargez pour continuer.",
      recharge: "Recharger 20 questions — 6 €",
      send: "Envoyer",
      thinking: "L'IA réfléchit…",
      open: "Ouvrir l'IA",
      close: "Fermer",
      welcome: "Bienvenue. Je suis l'IA experte FACOW360. Décrivez ce que vous ressentez, votre habitat, ou ce qui vous préoccupe — je croise tradition et données.",
    },
    forms: {
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      country: "Pays",
      city: "Ville",
      subject: "Sujet",
      message: "Message",
      surface: "Surface (m²)",
      property: "Type de bien",
      pillar: "Pilier concerné",
      submit: "Envoyer",
      submitting: "Envoi...",
      success: "Message bien reçu. Nous revenons vers vous rapidement.",
      error: "Une erreur est survenue. Réessayez.",
    },
    disclaimer: "⚠️ Les conseils et contenus FACOW360 ne se substituent pas à un avis médical. En cas de doute, consultez un professionnel de santé.",
    footer: {
      contact_title: "Nous écrire",
      legal: "© 2026 FACOW360 — Fabrice Marini · SIRET 10341399300017 · TVA non applicable (Art. 293 B du CGI). Plateforme d'alchimie digitale.",
      deontological_disclaimer: "Mes conseils culinaires s'appuient sur mon expérience professionnelle de cuisinier et ne constituent pas un bilan diététique ou médical. FACOW 360 met en œuvre des moyens techniques et sensibles, mais ne garantit aucun résultat sur des pathologies physiques ou psychologiques relevant de la médecine stricte.",
    },
    devis: {
      title: "Demande de devis",
    },
  },
  en: {
    nav: {
      home: "Home",
      genese: "Where does FACOW 360 come from?",
      geobiologie: "Geobiology",
      cuisine: "Living Cuisine",
      magnetisme: "Magnetism",
      sentinelles: "Green Sentinels",
      therapeutes: "Therapists",
      boutique: "Shop",
      bilan: "Vitality Assessment",
      tarifs: "Pricing",
      frequences: "Frequencies",
      devis: "Quote",
      contact: "Contact",
      legal: "Legal Notice & T&Cs",
    },
    home: {
      tagline: "Alchemy Platform",
      hero_left_title: "AI in service of the Living",
      hero_left_text: "The FACOW 360 method rests on strictly separated professional services: habitat analysis (Geobiology), energetic rebalancing (Magnetism) and Living Cuisine. The nutritional approach is rigorously articulated around 5 pillars: the blood-group system, Ayurveda, naturopathy, chronobiology and fasting.",
      hero_right_title: "Respect for Tradition",
      hero_right_text: "The wisdom of the Runes, Geobiology and Living Cuisine has guided our approach for millennia. We honour it without betraying it.",
      pillars_title: "3 Pillars of the FACOW 360 Method",
      pillars_sub: "Each pillar is strictly separated to preserve the clarity and depth of guidance.",
      cta_chat: "Consult the expert AI",
      bottom_phrase: "If you feel the need, an analysis would be ideal to restore proper balance.",
    },
    pillars: {
      geobiologie: {
        title: "Geobiology",
        short: "Habitat analysis (detection of disturbances and harmonisation of living spaces).",
      },
      cuisine: {
        title: "Living Cuisine",
        short: "Personalised nutritional advice and support.",
      },
      magnetisme: {
        title: "Magnetism",
        short: "Energetic rebalancing (release of tensions and harmonisation of flows).",
      },
      therapeutes: {
        title: "Recommended Therapists",
        short: "A network of vetted practitioners to extend the journey with rigour.",
      },
      boutique: {
        title: "Affiliate Shop",
        short: "A curated selection aligned with the seven reference books — no inventory, full transparency.",
      },
    },
    chatbot: {
      title: "FACOW360 — Expert AI",
      placeholder: "Ask your question...",
      free_left: "{n} free messages left",
      paid_left: "{n} messages left",
      locked: "No credits left. Recharge to continue.",
      recharge: "Recharge 20 questions — €6",
      send: "Send",
      thinking: "AI is thinking…",
      open: "Open AI",
      close: "Close",
      welcome: "Welcome. I'm FACOW360's expert AI. Describe what you feel, your habitat, or your concern — I weave tradition and data.",
    },
    forms: {
      name: "Full name",
      email: "Email",
      phone: "Phone",
      country: "Country",
      city: "City",
      subject: "Subject",
      message: "Message",
      surface: "Surface (m²)",
      property: "Property type",
      pillar: "Pillar of interest",
      submit: "Send",
      submitting: "Sending...",
      success: "Message received. We'll reply shortly.",
      error: "Something went wrong. Please retry.",
    },
    disclaimer: "⚠️ FACOW360 advice and content does not replace medical guidance. When in doubt, consult a healthcare professional.",
    footer: {
      contact_title: "Reach us",
      legal: "© 2026 FACOW360 — Fabrice Marini · SIRET 10341399300017 · VAT not applicable (Art. 293 B French CGI). Digital alchemy platform.",
      deontological_disclaimer: "My culinary guidance is based on my professional cooking experience and does not constitute a dietary or medical assessment. FACOW 360 deploys technical and sensitive means but guarantees no result on physical or psychological conditions falling under strict medicine.",
    },
    devis: {
      title: "Quote request",
    },
  },
};
